(function() {
	//타겟 요소 셋팅
	var targetlist = ["#stepInput", "#manualSection", "#driverSection", "#serviceMenu2"];
	
	var observeroptions = {
			root: null,
			rootMargin: '0px'
			//threshold: 0.3
		};
		
	// options에 따라 인스턴스 생성
	var observer = new IntersectionObserver(function(entries,observer) {
			entries.forEach(function(entry){
				// 루트 요소와 타겟 요소가 교차하면 dataset에 있는 이미지 url을    타겟요소의 src 에 넣어준다.
				if (entry.isIntersecting) {
					if(entry.target.id == 'stepInput'){
						observeSend('stepInput');
					}else if(entry.target.id == 'topicBox'){
						observeSend('제품에 나타난 증상을 선택해주세요');
					}else if(entry.target.id == 'manualSection'){
						observeSend('제품 사용설명서예요');
					}else if(entry.target.id == 'driverSection'){
						observeSend('드라이버예요');
					}else if(entry.target.id == 'serviceMenu'){
						observeSend('제품 문제가 아직 해결되지 않았나요? 다른 서비스를 이용해 보세요.');
					}else if(entry.target.id == 'serviceMenu2'){
						observeSend('제품 문제가 아직 해결되지 않았나요? 다른 서비스를 이용해 보세요.');
					}
					//타겟 요소 관찰 종료(1회만 보내기 위한 처리)
					observer.unobserve(entry.target);
				}
				})
			}, observeroptions);
	//옵저버 처리
	function observeSend(eventLabel) {
		var tabTitle = "";
		if ($('#solutions-tab').find('a[aria-controls="tab3"]').attr('aria-selected') == 'true'){
			tabTitle = "문제 해결 Q&A";
		}else{
			tabTitle = "다운로드 센터";
		}
		dataLayer.push({
			'event': 'customEvent',
			'ga4event': 'custom_event',
			'customEventCategory': '완독률',
			'customEventAction': '완독률 - 스스로해결 리스트',
			'customEventLabel': tabTitle +"-"+ eventLabel
		});
	};

	
	var manualListTemplate = 
		'<li {{#if typeof seq != "undefined"}}data-seq="{{seq}}"{{/if}} {{#if typeof language_list != "undefined"}}data-language="{{language_list}}"{{/if}} {{#if typeof date != "undefined"}}data-date="{{date}}"{{/if}} {{#if typeof fileId != "undefined"}}data-file-id="{{fileId}}"{{/if}}>' +
			'<p class="tit">{{type}}</p>' +
			'<p class="desc" style="white-space: pre-line;">{{title}}</p>' +
			'<div class="info-wrap">' +
				'{{# if (typeof language != "undefined" || typeof date != "undefined" || typeof os != "undefined" || language != "" || date !="" || os != "") { #}}' +
				'<ul class="options">' +
					'{{# if (typeof language != "undefined" || language != "") { #}}' +
					'<li>{{language}}</li>' +
					'{{# } #}}' +
					'{{# if (typeof date != "undefined" || date != "") { #}}' +
					'<li>{{date}}</li>' +
					'{{# } #}}' +
					// start 210621 BTOCSITE-1902 사용 설명서의 OS 정보 노출 요청 추가
					'{{# if (os != "") { #}}' +
					'<li>OS</li>' +
					'{{# } #}}' +
					'{{# if (os != "") { #}}' +
					'<li>{{os}}</li>' +
					'{{# } #}}' +
					// end 210621 BTOCSITE-1902 end-사용 설명서의 OS 정보 노출 요청 추가
				' </ul>' +
				'{{# } #}}' +
				'<div class="btn-wrap">' +
					'{{# for (var i = 0; i < file.length; i++) { #}}' +
					// BTOCSITE-25017 [운영] iOS PDF 다운 후 완료 선택 시 화면 비정상 노출되는 현상
					'<a href="{{file[i].src}}" class="btn border size btn-download" data-type="{{file[i].type}}" rel="noopener noreferrer" target="_blank" data-app-target="out"><span>{{file[i].str}}</span></a>' +
					'{{# } #}}' +
				'</div>' +
			'</div>' +
		'</li>';
	var driverListTemplate = 
		'{{#each (item, index) in listData}}' +
		'<li>' +
			'{{# if (typeof item.detailUrl != "undefined" && item.detailUrl) { #}}' +
			'<p class="tit"><button type="button" class="btn-info" data-href="{{item.detailUrl}}" data-file-id="{{item.fileId}}" data-cseq="{{item.cSeq}}" data-os="{{item.os}}" title="상세 내용 보기">{{#if item.os}}[{{item.os}}] {{/if}}{{item.title}}</button></p>' +
			'{{# } else { #}}' +
				'{{# if (typeof item.os == "string" && item.os) { #}}' +
				'<p class="tit">[{{item.os}}] {{item.title}}</p>' +
				'{{# } else { #}}' +
				'<p class="tit">{{item.title}}</p>' +
				'{{# } #}}' +
			'{{# } #}}' +
			'<div class="info-wrap">' +
				'{{# if (typeof item.category != "undefined" || typeof item.date != "undefined" || typeof item.file.size != "undefined") { #}}' +
				'<ul class="options">' +
					'{{# if (typeof item.category != "undefined") { #}}' +
					'<li>{{item.category}}</li>' +
					'{{# } #}}' +
					'{{# if (typeof item.date != "undefined") { #}}' +
					'<li>{{item.date}}</li>' +
					'{{# } #}}' +
					'{{# if (typeof item.file.size != "undefined") { #}}' +
					'<li>{{item.file.size}}</li>' +
					'{{# } #}}' +
				' </ul>' +
				'{{# } #}}' +
				'<div class="btn-wrap">' +
					'{{# if(!vcui.detect.isMobileDevice) { #}}' +
					// BTOCSITE-25017 [운영] iOS PDF 다운 후 완료 선택 시 화면 비정상 노출되는 현상
					//'<a href="{{item.file.src}}" class="btn border size btn-download" target="_blank" data-app-target="out"><span>다운로드 {{#if item.file.size}}{{item.file.size}}{{/if}}{{#if item.file.os}}{{item.file.os}}{{/if}}</span></a>' +
					'<a href="{{item.file.src}}" class="btn border size btn-download" target="_blank" data-app-target="out"><span>다운로드</span></a>' +
					'{{# } else { #}}' +
					'<a href="{{item.file.src}}" class="btn border size btn-download"><span>다운로드</span></a>' +
					'{{# } #}}' +
				'</div>' +
			'</div>' +
		'</li>' +
		'{{/each}}';
			
	var otherService = {
		template : 
			'<li>' +
				'<a href="{{url}}">' +
					'<div class="icon"><img src="{{imgUrl}}" alt=""></div>' + 
					'<p class="tit">{{name}}</p>' +
					/* '<p class="tit">{{desc}}</p>' + */
					'<p class="tit"></p>' +
				'</a>' +
			'</li>',
		el : {
			wrap : $('.common-banner'),
			title : $('.common-banner .banner-tit'),
			list : $('.common-banner .service-list')
		},
		initialize : function(data){
			var self = this;
	
			this.setMenuList(data);
		},
		reset : function(){
			var self = this;
			self.el.list.html('');
			self.el.wrap.hide();
		},
		setMenuList: function(data) {
			var self = this;
			var data = data.serviceMenu;
			var serviceList = data instanceof Array ? data : [];
			var htmlData = "";

			if( serviceList.length ) {
				serviceList.forEach(function(item){
					if(item.url == "/support/service-engineer-reservation" 
					|| item.url == "/support/request-call-reservation"
					|| item.url == "/support/visit-center-reservation"){
						  item.url += "?category="+ $('#category').val()
						  + "&subCategory="+ $('#subCategory').val()
						  + "&categoryNm=" + $('#categoryNm').val()
						  + "&subCategoryNm=" + $('#subCategoryNm').val()
						  + "&productCode=" + $('#productCode').val()
						  + "&mktModelCd=" + $('#modelCode').val()
						  + "&cstFlag=Y";
						
					}
					
					htmlData += vcui.template(self.template, item);
				});
				self.el.list.html(htmlData);
				self.el.wrap.show();
			} else {
				self.reset();
			}
		},
	};

	var relatedInfo = {
		el : {
			wrap : $('.related-info'),
			slider : $('.related-info .info-slider')
		},
		slideActiveClass : "is-active",
		slideConfig : {
			infinite: false,
			autoplay: false,
			slidesToScroll: 3,
			slidesToShow: 3,
			cssEase: 'cubic-bezier(0.33, 1, 0.68, 1)',
			speed: 150,
			touchThreshold: 100,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToScroll: 3,
						slidesToShow: 3
					}
				},
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						slidesToScroll: 1,
						slidesToShow: 1,
						variableWidth: true
					}
				},
				{
					breakpoint: 20000,
					settings: {
						slidesToScroll: 3,
						slidesToShow: 3
					}
				}
			]
		},
		initialize : function(){
			var self = this;
			vcui.require(['ui/carousel'], function () {    
				// LG제품에 관련된 정보를 확인하세요!
				if( !self.el.slider.hasClass(self.slideActiveClass) ) {
					self.el.slider.not('.is-active').vcCarousel(self.slideConfig);
					self.el.slider.addClass(self.slideActiveClass);
				} else {
					var activeSlider = self.el.slider.filter('.' + self.slideActiveClass);
					activeSlider.vcCarousel('update');
					activeSlider.vcCarousel('reinit');
				}
				self.el.wrap.show();
			});
		},
		reset : function(){
			this.el.wrap.hide();
		}
	}

	var detect = vcui.detect;

	
	$(window).ready(function() {
		var download = {
			options: {
				category: '',
				categoryNm: '',
				subCategory: '',
				subCategoryNm: '', 
				modelCode: '', 
				productCode: '',
				page:1
			},
			emailValidate : null,
			initialize: function() {
				var self = this;

				self.$cont = $('.contents');
				self.$selectedModelBar = self.$cont.find('.goods-selected-wrap'); //선택된 제품정보
				self.$myModelWrap = self.$cont.find('.my-product-wrap'); // 보유제품
				self.$prodSearchWrap = self.$cont.find('.prod-search-wrap'); // 제품정보 입력
				self.$tabProd = self.$cont.find('#tabs-prod'); // 탭

				self.$stepArea = self.$cont.find('.step-area');
				self.$stepInput = self.$stepArea.find('#stepInput');

				//서비스 화면
				self.$contentsjobDiv = self.$cont.find('#contents-job');

				//manual-section
				self.$manualSec = self.$cont.find('.manual-section');
				self.$manualModel = self.$manualSec.find('#manualModel');   //매뉴얼 모델표시
				self.$manualCnt = self.$manualSec.find('#manualCnt');
				self.$manualPagination = self.$manualSec.find('.pagination');
				
				//driver-section
				self.$driverSec = self.$cont.find('.driver-section');
				self.$driverCnt = self.$driverSec.find('#driverCnt');
				self.$driverPagination = self.$driverSec.find('.pagination');
				
				self.$surveyWrap = self.$cont.find('.survey-banner-wrap');

				self.$surveyPopup = self.$cont.find('#surveyPopup');
				self.$fileDetailPopup = $('#fileDetailPopup');
				
				
				//다운로드 타이틀 부분
				// self.$driverModel = $('#driverModel');   //매뉴얼 모델표시
				// self.$driverCnt = $('#driverCnt');       //매뉴얼 건수 표시
				// self.$driverSection = $('#driverSection'); //메뉴얼 창
				
				
				// 모델명 검색
				self.$modelBox = self.$stepArea.find('#model-box');
				self.$modelInput = self.$modelBox.find('input[type=text]');
				self.$modelButton = self.$modelBox.find('.btn-search');
				self.$modelError = self.$modelBox.find('.search-error');
				
				// 모델명 검색
				self.$modelCodeSearchBox = self.$cont.find('#modelcodeSearch');
				self.$modelCodeSearch = self.$modelCodeSearchBox.find('.keyword-search');
				self.$modelCodeSearchInput = self.$modelCodeSearchBox.find('input[type=text]');
				self.$modelCodeSearchButton = self.$modelCodeSearchBox.find('.btn-search');
				
				//BTOCSITE-80487 고객지원 > 출장예약 > 모델명 입력 > 자동완성 미선택
				if(lgkorUI.getParameterByName('mpFlag') == 'Y'){
					self.$tabProd.vcTab('select', 1);
				}

				vcui.require(['support/common/searchModelNew.min', 'ui/validation'], function () {
					if (detect.isMobileDevice) {
						var emailRegister = {
							userEmail : {
								required: true,
								pattern : /([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
								minLength: 1,
								maxLength: 50,
								msgTarget: '.err-block',
								errorMsg: '이메일 주소를 입력해주세요.',
								patternMsg: '올바른 이메일 형식이 아닙니다.',
								validate : function(value){
									var _pattern = new RegExp(this.pattern);
			
									if( _pattern.test(value) == true) {
										if( value.split('@')[0].length <= 30 && value.split('@')[1].length <= 20) {
											return true;
										} else {
											return false;
										}
									} else {
										return false;
									}
								}
							}
						}
		
						self.emailValidate = new vcui.ui.CsValidation('#fileSendToEmail', {register:emailRegister});
					}

					self.setting();
					self.bindEvent();

					if (!self.isPSP) {
						self.$cont.vcSearchModelNew({model:self.param});
					} else {
						$.extend(self.manualPara, {
							category:      $('#category').val(),
							categoryNm:    $('#categoryNm').val(), 
							subCategory:   $('#subCategory').val(),
							subCategoryNm: $('#subCategoryNm').val(), 
							modelCode:     $('#modelCode').val(),
							productCode:   $('#productCode').val()
						});
						$.extend(self.driverParam, {
							category:      $('#category').val(),
							categoryNm:    $('#categoryNm').val(), 
							subCategory:   $('#subCategory').val(),
							subCategoryNm: $('#subCategoryNm').val(), 
							modelCode:     $('#modelCode').val(),
							productCode:   $('#productCode').val()
						});
					}


					//self.$manualPagination.data('page', 1);
					//self.$driverPagination.pagination(); //2023.04.28 paging 중복생성

					if($('#preLoad').val() == "Y"){
						//download.setting();
						self.onLoadmktModel();
						// $('#solutions-tab').trigger('click');
						self.downloadSearchChk();
						
	
						if(Number(self.$tabProd.data('modelCnt')) > 0) self.$myModelWrap.hide();
						self.$contentsjobDiv.show();
						self.$stepInput.addClass('active');
					}
			
					
				});

				// 모델명 입력 / 검색 Input Box 모델명 검색 글자수 제한
				self.$modelInput.attr('maxlength','30');
				self.$manualPagination.pagination();
				self.$driverPagination.pagination();

			},
			setting: function() {
				var self = this;
				var data = $.extend({}, self.options);

				// 옵션
				self.resultUrl = "/support/manuals/searchManualDriver.lgajax";
				self.manualUrl = self.$manualSec.data('manualUrl');
				self.driverUrl = self.$driverSec.data('driverUrl');
				self.isPSP = self.$cont.hasClass('psp');
				self.isLogin = lgkorUI.isLogin;
				self.param = $.extend({}, data);
				self.manualParam = $.extend({}, data, {
					type: 'manual'
				});
				self.driverParam = $.extend({}, data, {
					keyword: '',
					type: 'driver'
				});

				// BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
				self.salesCodeForUTM = ''; //세일즈 코드
				//  PSP 진입시
				if(!!$('#salesModelCodeForUTM').val()){
					self.salesCodeForUTM = $('#salesModelCodeForUTM').val();
					self.searchModelRDate();
				}
			},
			setManualList: function(data) {
				var self = this;
				var $listWrap  = self.$manualSec.find('.download-list-wrap'),
					$list = $listWrap.find('.download-list'),
					$noData = self.$manualSec.find('.no-data');
				var listArr = data.listData instanceof Array ? data.listData : [];
					page = data.listPage,
					html = "";

				self.$manualCnt.html(page.totalCount);
				//var titledata = '<span class="point" id="manualModel">' + $('#subCategoryNm').val() + '</span> 제품 사용설명서예요'
				if (listArr.length) {
					listArr.forEach(function(item) {
						// BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
						self.salesCodeForUTM = item.sales_model_cd; //세일즈코드 for utm
						
						var fileList = [];
						item.file.forEach(function(item2){
							var obj={};
							obj.src=item2.src
							obj.type=item2.type
							obj.str=(item2.type.toUpperCase()=="HTML")?"바로보기":"다운로드"      /* zip jslee */
							fileList.push(obj);
						});
						item.file = fileList
						
						html += vcui.template(manualListTemplate, item);
					});
					$list.html(html);
					$listWrap.show();
					$noData.hide();

					// BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
					self.searchModelRDate(); // sales date
					self.$manualModel.html($('#subCategoryNm').val());
					self.$manualCnt.html(listArr.length);
					self.$manualSec.find('.form-wrap.form-downset').show();
				} else {
					$listWrap.hide();
					$list.empty();
					$noData.show();
					self.$manualModel.html($('#subCategoryNm').val());
					self.$manualCnt.html('0');
					self.$manualSec.find('.form-wrap.form-downset').hide();
					
				}
				//$("#manualtitle").html(titledata);
				self.$manualPagination.pagination('update', page);
				// self.$manualPagination[page.view == 'Y' ? 'show': 'hide']();
				
				
				/*
				if(page.view=='Y'){
					self.$manualPagination.css('display','block');
				}else{
					self.$manualPagination.css('display','none');
				}
				*/
			},
			setDriverList: function(data) {
				var self = this;
				var $listWrap = self.$driverSec.find('.download-list-wrap'),
					$list = $listWrap.find('.download-list'),
					$noData = self.$driverSec.find('.no-data');
				var listArr = data.listData instanceof Array ? data.listData : [],
					page = data.listPage,
					html = "";
				
				self.$driverCnt.html(page.totalCount);
				if (listArr.length) {
					html = vcui.template(driverListTemplate, data);
					$list.html(html);
					$listWrap.show();
					$list.find('>li').each(function(i) {
						var $this = $(this);
						for (var key in listArr[i]) {
							if (key == 'file') {
								if (listArr[i][key].os) $this.data('os', listArr[i][key].os);    
								continue;
							}
							$this.data(key.toString(), listArr[i][key]);
						}
					});
					$noData.hide();
					self.$driverPagination.show();
					self.$driverPagination.pagination('update', page);
					//제목부분
					//titledata = '<span class="point" id="driverModel">'+ $('#subCategoryNm').val() + '</span> 드라이버예요 <span class="point" id="driverCnt">'+ page.totalCount +'</span>건';
					self.$driverSec.find('.form-wrap.form-downset').show();
					self.setOsActive(data.osOption);
					$('#driverModel').html($('#subCategoryNm').val());
					self.$driverCnt.html(page.totalCount);
				} else {
					$listWrap.hide();
					$list.html('');
					$noData.show();
					self.$driverPagination.hide();
					self.$driverSec.find('.form-wrap.form-downset').hide();
					$('#driverModel').html($('#subCategoryNm').val());
					self.$driverCnt.html('0');
				}
				//$("#drivertitle").html(titledata);
				//$('#driverModel').html($('#subCategoryNm').val());
				//self.$driverCnt.html(page.totalCount);
				self.$modelInput.val(self.driverParam.keyword);
			},

			setOsOption: function(data) {
				var self = this;
				var $select = self.$driverSec.find('#os');
				var listArr = data instanceof Array ? data : [],
					html = "";

				if (listArr.length) {
					listArr.forEach(function(item) {
						html += vcui.template('<option value="{{code}}">{{codeName}}</option>', item);
					});
				} else {
					html = '<option value="">없음</option>';
					$select.vcSelectbox('disabled');
				}
				
				$select.html(html);
				$select.vcSelectbox('update');
			},
			setOsActive: function(os) {
				var self = this;
				var $formWrap = self.$driverSec.find('.form-wrap');
				var $listDesc = self.$driverSec.find('.download-list-wrap > .desc');
				var category = self.param.category;
				var subCategory = self.param.subCategory;
				//CT50019564 노트북/모니터 , CT50019585 IT / 모니터  , CT50019082 TV / 프로젝터
				if (subCategory == "CT50019564" || subCategory == "CT50019585" ||  subCategory == "CT50019082") {   // ||  subCategory == "CT50019021" 추가  tv모댈
					self.setOsOption(os);
					$formWrap.show();
				} else {
					$formWrap.hide();
				}
				
				if (category == "CT50019096") {
					$listDesc.hide();
				} else {
					$listDesc.show();
				}
			},
			setSurvey: function(data) {
				var self = this;
				var model = self.param.modelCode;
				
				if (data) {
					self.$surveyWrap.find('.point').html(model);
					self.$surveyPopup.find('.model').html(model);
				
					for (var key in data) {
						self.$surveyPopup.find('[name='+key+']').length && self.$surveyPopup.find('[name='+key+']').val(data[key]);
					}
				}
			},
			searchAllList: function() {
				var self = this;
				var param = $.extend({}, self.param, {
					category: $('#category').val(),
					categoryNm: $('#categoryNm').val(), 
					subCategory: $('#subCategory').val(),
					subCategoryNm: $('#subCategoryNm').val(),
					modelCode: $('#modelCode').val(),
					productCode: $('#productCode').val(),
				});
				
				
				lgkorUI.setAcecounter('www.lge.co.kr/acecount/driverList.do', '/acecount/driverListm.do');       
				//delete param.keyword;

				self.$cont.vcSearchModelNew('updateSummary', {
					product: [param.categoryNm, param.subCategoryNm, param.modelCode],
					isMyProduct: $('#isMyProduct').val(),
					reset: 'product'
				});

				lgkorUI.showLoading();
				lgkorUI.requestAjaxData(self.resultUrl, param, function(result){
					var data = result.data;
					
					if (result.status == 'fail') {
						var data = {
							manual: {
								listPage: {
									totalCount: 0
								}
							},
							driver: {
								osOption: '',
								listPage: {
									totalCount: 0
								}
							},
							satisfy: ''
						}
						self.$surveyWrap.hide();
					} else {
						self.$surveyWrap.show();
					}
					

					self.setManualList(data.manual);
					self.setDriverList(data.driver);
					// self.setOsActive(data.driver.osOption);


					
					self.isLogin && self.$myModelWrap.hide();
					
					//업데이트 센터 바로가기 배너
					self.bannerToggle(param.subCategory);
					//$('#manualSection').before($('.banner-wrap.toggle-banner'));
					

					//하단 다른 서비스 추천
					otherService.initialize(data);

					//하단 관련 메뉴
					relatedInfo.initialize(data);

					//만족도 평가 박스 모델코드 삽입
					self.setSurvey(data.satisfy);

					self.scrollDefSet();
					
					lgkorUI.hideLoading();
				}, 'GET', 'json' ,true); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
			},
			// BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
			setUTM: function(rdate){
				var self = this;
				var $list = self.$manualSec.find('.download-list');

				var arrBusiCode = ['CNZ', 'DFZ', 'DVZ', 'CVZ', 'DLZ', 'DMZ', 'DGZ', 'CDZ', 'ANZ', 'SIG', 'SAP']; // GA사업부코드
				var utm_source = isApp() ? 'app' : 'lgweb',
					utm_medium = 'dotcom',
					utm_campaign = 'base',
					model = self.salesCodeForUTM, // 세일즈 코드
					rdate = rdate ? rdate : '',
					htmlParam = '';
				
				htmlParam = "?utm_source="+utm_source+"&utm_medium="+utm_medium+"&utm_campaign="+utm_campaign+"&model="+model+"&rdate="+rdate;

				$list.find('>li').each(function(i) {
					var $this = $(this);

					$(this).find('a').each(function(index, item){
						var itemHref = item.getAttribute('href');
						var itemType = item.getAttribute('data-type');
						var busiCode = itemHref.split('/')[3]; 

						var isGscs = itemHref.includes('gscs-manual.lge.com');
						var isBusiCode = arrBusiCode.includes(busiCode); //사업부 체크
						var isParam = itemHref.indexOf('?') === -1;
						
						if(itemType == 'html' && isGscs && isBusiCode && isParam) {
							item.setAttribute("href", itemHref + htmlParam);
						}
					});
				});
			},
			// BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청
			searchModelRDate: function(){
				var self = this;
				var ajaxUrl = '/support/manuals/searchModelRDate.lgajax';

				if(!lgkorUI.isLogin){
					self.setUTM();
				}else{
					// 메인, 상단 보유 제품 선택시
					if(!!$('#salesDateForUTM').val()){
						self.setUTM($('#salesDateForUTM').val());
					}else{
						lgkorUI.showLoading();
						lgkorUI.requestAjaxDataPost(ajaxUrl, {'salesModelCd': self.salesCodeForUTM}, function(result){
							var data = result.data == null ? '' : result.data.salesDt;
							if(result.resultFlag == 'Y'){
								self.setUTM(data); // sales date 가져와서 url에 UTM 정보 상입
							}
							lgkorUI.hideLoading();
						});
					}
				}
			},
            scrollDefSet: function(){
                observer.disconnect();
                targetlist.forEach(function(target) {
                    // 타겟 요소 관찰 시작
                    var target = document.querySelector(target);
                    observer.observe(target);
                });
            },	
			searchManualList: function() {
				var self = this;
				lgkorUI.showLoading();
				lgkorUI.requestAjaxData(self.manualUrl, self.manualParam, function(result){
					self.setManualList(result.data.manual);
					lgkorUI.hideLoading();
				},'GET'); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
			},
			
			searchDriverList: function() {
				var self = this;
				self.driverParam = $.extend(self.driverParam, {
					category: $('#category').val(),
					categoryNm: $('#categoryNm').val(), 
					subCategory: $('#subCategory').val(),
					subCategoryNm: $('#subCategoryNm').val(),
					modelCode: $('#modelCode').val(),
					productCode: $('#productCode').val(),
					type: 'driver'
				});
				
					
				lgkorUI.showLoading();
				lgkorUI.requestAjaxData(self.driverUrl, self.driverParam, function(result){
					self.setDriverList(result.data.driver);
					lgkorUI.hideLoading();
				},'GET'); // BTOCSITE-31644 고객지원 > 검색엔진 성능 향상/고객지원 페이지 내 검색 기능 수정 요청
				
			},
			// _requestTopicData: function _requestTopicData() { //다운로드 센타 검색엔진에서 조회
			// 	return;
			// },
			_requestSearchEngine: function _requestSearchEngine() {
				return;
				/* var self = this,
					url = self.$keywordSearchWrap.data('autocompleteUrl');

				lgkorUI.showLoading();
				lgkorUI.requestAjaxData(url, self.param, function(result) {
					var resultData = result.data;
					
					if(resultData.listData.length > 0) {
						$('#productCode').val(resultData.listData[0].productCode);
					}
				}); */
			},
			// onLoadTabControl: function(){
			// 	var linkTab = $('.container').attr('linkTabCode');
			// 	if(linkTab == 1){
			// 		$('#solutions-tab').find('a[aria-controls="tab3"]').trigger('click');
			// 	}else{
			// 		$('#solutions-tab').find('a[aria-controls="tab4"]').trigger('click');
			// 	}
			// },
			onLoadmktModel: function(){  //모댈코드 물고 넘어올경우
				var self = this;
				$.extend(self.param, {
					category:      $('#category').val(),
					categoryNm:    $('#categoryNm').val(), 
					subCategory:   $('#subCategory').val(),
					subCategoryNm: $('#subCategoryNm').val(), 
					modelCode:     $('#modelCode').val(),
					productCode:   $('#productCode').val()
				});
				
				$.extend(self.manualPara, {
						category:      $('#category').val(),
						categoryNm:    $('#categoryNm').val(), 
						subCategory:   $('#subCategory').val(),
						subCategoryNm: $('#subCategoryNm').val(), 
						modelCode:     $('#modelCode').val(),
						productCode:   $('#productCode').val()
				});
				$.extend(self.driverParam, {
						category:      $('#category').val(),
						categoryNm:    $('#categoryNm').val(), 
						subCategory:   $('#subCategory').val(),
						subCategoryNm: $('#subCategoryNm').val(), 
						modelCode:     $('#modelCode').val(),
						productCode:   $('#productCode').val()
				});


				// self.searchAllList();
				// self.onLoadTabControl();  //스스로 해결진입 기준으로 탭 표시
			},
			downloadSearchChk: function(){
				if( $('#modelCode').val().length > 0){
					$('#modelcodeSearch').hide();
				}else{
					$('#modelcodeSearch').show();
				}
			},
			bannerToggle: function(modelType){

				var $banner = $('.banner-wrap.toggle-banner');

				if( modelType == undefined) {
					$banner.hide();
				}

				if( modelType == "CT50019564" || modelType == "CT50019585") {
					$banner.show();
				} else {
					$banner.hide();
				}
			},
			reset: function() {
				var self = this,
					data = $.extend({}, self.options);

				self.param = data;
				self.manualParam = $.extend({}, data, {
					type: 'manual'
				});
				self.driverParam = $.extend({}, data, {
					keyword: '',
					type: 'driver'
				});

				self.$manualSec.find('.download-list').empty();
				self.$manualPagination.data('page', 1);

				self.$driverSec.find('.download-list').empty();
				self.$driverSec.find('.old-keyword').remove();
				self.$modelInput.val('').trigger('update');
				$('#driverKeyword').val(''); 
				$('#salesDateForUTM').val(''); // BTOCSITE-31495 H&A 제품 사용 설명서 호출 시 유입 경로 파악을 위한 UTM 정보 삽입 요청

				
				//bannerToggle();
				
				
				self.$modelCodeSearch.find('.search-error').hide();
				self.$modelCodeSearchInput.val('');



				// self.$modelBox.find('.keyword-search').show();					
				self.$modelInput.val('');
				//self.$modelSlider.find('.slide-track').empty();
				self.$modelBox.find('#categorySelect').find('option:first-child').prop('selected', true);
				self.$modelBox.find('#categorySelect').vcSelectbox('update');
				self.$modelBox.find('#subCategorySelect').find('option:not(.default)').remove();
				self.$modelBox.find('#subCategorySelect').vcSelectbox('update');
				$('#prdGrp02').hide();

				self.$selectedModelBar.vcSticky('destroy');
				self.$selectedModelBar.hide();
				self.$contentsjobDiv.hide();
				self.$stepInput.removeClass('active');

				self.$tabProd.show();
				self.$myModelWrap.show();
				


				otherService.reset();
				relatedInfo.reset();


				

				// 문제해결Q&A : B00013, 다운로드센터 : A00030
				if($('#pageCode').val() === 'A00030') {
					$('.banner-wrap.toggle-banner').show();
				}else if($('#pageCode').val() === 'B00013') {
					$('.banner-wrap.toggle-banner').hide();
				}
				
				self.$cont.find('.ui_input_clearbutton').vcInputClearButton('updateVal', '');
				// $('#modelcodeSearch').find('#no-keyword').hide();

				
			},
			bindEvent: function() {
				var self = this;
				lgkorUI.hideLoading();
				
				// 보유제품 선택
				self.$cont.on('complete', function(e, data) {    

					$.extend(self.param, data);
					$.extend(self.manualParam, data);
					$.extend(self.driverParam, data);

					self.searchAllList();
					
					self.$selectedModelBar.show(); // 플로팅바 노출
					self.$stepArea.show(); // 정보 입력창 노출
					// self.$searchArea.hide();
					self.$myModelWrap.hide(); // 제품 리스트 은폐
					
					// var linkTab = $('.container').attr('linkTabCode');	
					// if(linkTab == 1){
					// 	$('#solutions-tab').find('a[aria-controls="tab3"]').trigger('click');
					// }else{
					// 	$('#solutions-tab').find('a[aria-controls="tab4"]').trigger('click');
					// }
					self.downloadSearchChk();


					self.$tabProd.hide();
					self.$prodSearchWrap.hide();
					self.$contentsjobDiv.show();

					if($('#modelCode').val() == ""){
						$('#notmodel').show();
						self.$stepInput.removeClass('active');
					}else{
						$('#notmodel').hide();
						self.$stepInput.addClass('active');
					}
				}).on('reset', function(e) {
					self.reset();
				});

				// 모델명 검색, 카테고리 선택
				vcui.PubSub.on('completeSummary', function (e, data) {
					var param = {
						category: data.category,
						categoryNm: data.categoryNm,
						subCategory: data.subCategory,
						subCategoryNm: data.subCategoryNm,
						modelCode: data.modelCode,
						salesModelCode: data.salesModelCode,
						productCode: data.productCode,
					};
						
					$.extend(self.param, param);
					$.extend(self.manualParam, param);
					$.extend(self.driverParam, param);
					
					if(param.category !== '' && param.subCategory !== ''){
						
						self.$selectedModelBar.show(); // 플로팅바 노출
						self.searchAllList();
						self.downloadSearchChk();

						self.$tabProd.hide();
						self.$prodSearchWrap.hide();
						self.$contentsjobDiv.show();

						if($('#modelCode').val() == ""){
							$('#notmodel').show();
							self.$stepInput.removeClass('active');
						}else{
							$('#notmodel').hide();
							self.$stepInput.addClass('active');
						}

					}
				})
				
				// 변경
				self.$selectedModelBar.on('click', '.btn-reset', function() {
					self.reset();
				});


				// 모델명 검색
				self.$modelBox.on('click', '.search-layer .autocomplete-box a', function(e) {   //autocomplete 선텍시
					e.preventDefault();

					self.$contentsjobDiv.show();
					self.$stepInput.addClass('active');
					self.$tabProd.hide();
					$.extend(self.param, {
						category:      $('#category').val(),
						categoryNm:    $('#categoryNm').val(), 
						subCategory:   $('#subCategory').val(),
						subCategoryNm: $('#subCategoryNm').val(), 
						modelCode:     $('#modelCode').val(),
						productCode:   $('#productCode').val()
					});
					
					$.extend(self.manualPara, {
							category:      $('#category').val(),
							categoryNm:    $('#categoryNm').val(), 
							subCategory:   $('#subCategory').val(),
							subCategoryNm: $('#subCategoryNm').val(), 
							modelCode:     $('#modelCode').val(),
							productCode:   $('#productCode').val()
					});
					$.extend(self.driverParam, {
						category:      $('#category').val(),
						categoryNm:    $('#categoryNm').val(), 
						subCategory:   $('#subCategory').val(),
						subCategoryNm: $('#subCategoryNm').val(), 
						modelCode:     $('#modelCode').val(),
						productCode:   $('#productCode').val()
					});
					// self.searchAllList();
					// self.onLoadTabControl();  //스스로 해결진입 기준으로 탭 표시
					// self.downloadSearchChk();
				});

				

				//키워드 입력후 엔터시 검색
				self.$modelInput.on('keyup', function(e){
					if (e.keyCode == 13) {
						e.preventDefault();
						self.$modelButton.trigger('click');
					}

				}).on('input', function() {
					var $error = self.$modelCodeSearch.find('.search-error');
					var keyword = $(this).val().trim();

					keyword.length && $error.hide(); 
				});

				// 카테고리 > 검색어 버튼 클릭
				self.$modelButton.on('click', function() {
					var value = self.$modelInput.val().toUpperCase();

					if (value.length > 1 || !value) {
						self.param = $.extend(self.param, {
							keyword: value,
							page: 1
						});

						// self._requestTopicData();
						self.$modelError.hide();
					} else {
						self.$modelError.show();
					}
					
				});


				//언어선택
				self.$manualSec.find('#lang').on('change',function(e) {
					//var language_val = e.target.getAttribute('value');
					var language_val =$('#lang').find("option:selected").attr("value");
					
					self.manualParam = $.extend(self.manualParam, {
						category:      $('#category').val(),
						categoryNm:    $('#categoryNm').val(), 
						subCategory:   $('#subCategory').val(),
						subCategoryNm: $('#subCategoryNm').val(), 
						modelCode:     $('#modelCode').val(),
						productCode:   $('#productCode').val(),
						language_list : language_val,
						page: 1
					});
					self.searchManualList();
				});	
				self.$driverSec.find('#os').on('change', function() {
					self.driverParam = $.extend(self.driverParam, {
						os : $('#os').val(),
						page: 1
					});
					self.searchDriverList();
				});
				//다운로드 페이징
				self.$driverSec.find('.pagination').on('pageClick', function(e) {
					self.driverParam = $.extend(self.driverParam, {
						page: e.page
					});

					self.searchDriverList();
				});

				
				//매뉴얼 페이징
				self.$manualSec.find('.pagination').on('pageClick', function(e) {
					self.driverParam = $.extend(self.manualParam, {
						page: e.page
					});

					self.searchManualList();
				});
				
				self.$driverSec.on('click', '.btn-info', function() {    //다운로드 상세 페이지
					var $this = $(this);
					var url = $this.data('href'),
						param = $.extend(self.param, {
							fileId: $this.data('fileId'),
							cSeq: $this.data('cseq'),
							os: $this.data('os')
						});
					lgkorUI.requestAjaxData(url, param, function(result){
						self.$fileDetailPopup.html(result).vcModal();
					}, null, "html", true);
				});

				self.$manualSec.on('click', '.btn-download', function() {
					var fileType = $(this).data('type').toLowerCase();
					
					if (fileType == 'pdf') {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/driveManualPDF.do', '/acecount/driveManualPDFm.do');
					} else  if (fileType == 'zip') {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/driveManualZIP.do', '/acecount/driveManualZIPm.do');
					} else if (fileType == 'html') {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/driveManualHTML.do', '/acecount/driveManualHTMLm.do');
					} else if (fileType == 'chm') {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/driveManualCHM.do', '/acecount/driveManualCHMm.do');
					}
				});

				// 다운로드 버튼 클릭
				self.$driverSec.on('click', '.btn-download', function(e){
					var $this = $(this);
					var fileUrl = $this.attr('href');
					var $item = $this.closest('li');
					var data = $item.data();

					if (detect.isMobileDevice) {
						e.preventDefault();
						for(var key in data) {
							$('#fileSendToEmail').data(key, data[key]);
						}
						$('#fileSendToEmail').data('fileUrl', fileUrl).vcModal();
					} else {
						lgkorUI.setAcecounter('www.lge.co.kr/acecount/driveDownloadClick.do', '/acecount/driveDownloadClickm.do');
					}
				});

				self.$fileDetailPopup.on('click', '.btn-more', function() {
					var $list = $(this).parent();

					if ($list.hasClass('on')) {
						$list.removeClass('on');
					} else {
						$list.addClass('on');
					}
				});

				self.$fileDetailPopup.on('click', '.btn-download', function() {
					lgkorUI.setAcecounter('www.lge.co.kr/acecount/driveDownloadClick.do', '/acecount/driveDownloadClickm.do');
				});



				//이메일 주소 입력팝업 보내기 버튼 클릭시 
				$('#fileSendToEmail').on('click', '.btn-send', function(e){
					var $this = $(this);
					var $popup = $this.closest('#fileSendToEmail');
					var _url = $popup.data('ajax');
					var _fileUrl = $popup.data('fileUrl');
					
					if( self.emailValidate.validate().success ) {
						var param = {
							email : $popup.find('#userEmail').val(),
							fileUrl : _fileUrl,
							category: self.param.category,
							categoryNm: self.param.categoryNm,
							subCategory: self.param.subCategory,
							subCategoryNm: self.param.subCategoryNm,
							modelCode: self.param.modelCode,
							title: $popup.data('title'),
							os: $popup.data('os') || '',
							date: $popup.data('date') || $popup.data('issue_date') || ''
						};

						lgkorUI.requestAjaxDataPost(_url, param, function(result){
							var data = result.data;
							
							lgkorUI.alert("", {
								title: data.resultMessage,
								ok: function(el) {
									$(el).vcModal('hide');
									$('#fileSendToEmail').vcModal('hide');
								}
							});
						})
					}
				});

				//이메일 주소 입력팝업 닫기버튼 클릭시 이메일주소값 초기화
				$('#fileSendToEmail').on('modalhide', function(){
					var $this = $(this);

					self.emailValidate.reset();
					$this.data('fileUrl', '');
					$this.find('#userEmail').val('');
				});
				// BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
				var $imgView = $('.btn-img-view');
				$('#select2').on('change', function(){
		
					// 이미지가 없는 경우 no-img 삭제
					if(!(lgkorUI.NO_IMAGE_MODEL_NAME != $imgView.find('img').attr('src'))) {
						$imgView.find('img').removeClass('no-img');
					}
				});

				// BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
				$imgView.on('click', function(e) {
					e.preventDefault();
				
					if($(this).find('img').hasClass('no-img')) return;
		
					var domain=location.origin;
					var agent = navigator.userAgent;
					var imgUrl=domain + $(this).attr('href');
					var imgAlt = $(this).find('img').attr('alt');
					if(!vcui.detect.isMobileDevice){
						window.open(imgUrl, '', '');
						return
					}

					var currOption = $('#select2 option:selected');
					var popTitle = currOption.hasClass('placeholder') ? '모델명 확인 방법' : currOption.text();
					var $zoomPopup = $('#imgZoomPopup');
					var $zoomImg = $('#imgZoomPopup img');
					$zoomImg.attr('src', imgUrl);
					$zoomImg.attr('alt', imgAlt);

					$zoomPopup.find('.tit').html('<span>'+popTitle+'</span>');
					$zoomPopup.vcModal('open');
				});
				

				//서브카테고리
				self.$modelBox.on('change', '#subCategorySelect' , function() {   //보유 재품에서 카테고리 선택시 하단 활성화
					self.$tabProd.hide();
					// $('.goods-selected-wrap').show();
					// self.onLoadTabControl();  //스스로 해결진입 기준으로 탭 표시
					// $('#solutions-tab').trigger('click');

					if($('#modelCode').val() == ""){
						$('#notmodel').show();
						self.$stepInput.removeClass('active');
						return;
					}else{
						$('#notmodel').hide();
						self.$stepInput.addClass('active');
					}
				});

				
				
				self.$modelBox.on('keyup', 'input[type=text]', function(e) {
					//영문이나 숫자로 이루어진 모델명을 2자 이상 입력해주세요.
					self.$modelBox.find('.search-error').html('영문이나 숫자로 이루어진 모델명을 2자 이상 입력해주세요.');
					self.$modelBox.find('.search-error').hide();
					var searchVal = $('#search').val().toUpperCase();

					if (e.keyCode == 13) {  
						e.preventDefault();
						var chkdata = self.$modelBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');
						if(chkdata.length > 0){
							chkdata.trigger('click');             
						}else{
							self.$modelBox.find('.search-error').html('"'+searchVal+'"에 대한 검색 결과가 없습니다.')
							self.$modelBox.find('.search-error').show();
						}
					}
				});

				
				self.$modelBox.find('.btn-search').on('click', function(e){
					e.preventDefault();
					var searchVal = $('#search').val().toUpperCase();
					var chkdata = self.$modelBox.find('.keyword-list').find('li').find('[data-model-code="'+searchVal+'"]');

					if(chkdata.length > 0){
						chkdata.trigger('click');                    
					}else{
						self.$modelBox.find('.search-error').html('"'+searchVal+'"에 대한 검색 결과가 없습니다.')
						self.$modelBox.find('.search-error').show();
					}
				
				});


				//모델명 검색
				self.$modelCodeSearchBox.on('keyup', 'input[type=text]', function(e) {
					self.$modelCodeSearchBox.find('.no-keyword.type2').hide();
					self.$modelCodeSearchBox.find('.no-keyword').hide();
					if($('#driverKeyword').val().length == 0){
						self.$modelCodeSearchBox.find('.no-keyword.type2').hide();
						self.$modelCodeSearchBox.find('.no-keyword').hide();
					}else if($('#driverKeyword').val().length > 0 && $('#driverKeyword').val().length < 3){
						self.$modelCodeSearchBox.find('#no-keyword').show();
					}
					
					if (e.keyCode == 13) {  
						e.preventDefault();
						var chkdata = self.$modelCodeSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
						if($('#driverKeyword').val().toUpperCase() == chkdata){
							self.$modelCodeSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
						}else{
							if($('#driverKeyword').val().length > 2){
								self.$modelCodeSearchBox.find('.no-keyword.type2').html('"'+$('#driverKeyword').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
								self.$modelCodeSearchBox.find('.no-keyword.type2').show();
							}
						}
					}
				});
				//모델명 검색
				self.$modelCodeSearchBox.find('.btn-search').on('click', function(e){
					e.preventDefault();
					var chkdata = self.$modelCodeSearchBox.find('.keyword-list').find('li').find('a').attr('data-model-code');
					if($('#driverKeyword').val().toUpperCase() == chkdata){
						self.$modelCodeSearchBox.find('.keyword-list').find('li').find('a').trigger('click');                    
					}else{
						if($('#driverKeyword').val().length > 2){
							self.$modelCodeSearchBox.find('.no-keyword.type2').html('"'+$('#driverKeyword').val().toUpperCase()+'"에 대한 검색 결과가 없습니다.')
							self.$modelCodeSearchBox.find('.no-keyword.type2').show();
						}
					}

					self.bannerToggle($('#driverKeyword').val());
				});

				//모델명 검색
				self.$modelCodeSearchInput.on('keyup', function(e) {
					if (e.keyCode == 13) {
						e.preventDefault();
						self.$modelCodeSearchButton.trigger('click');
					}
				});
				//모델명 검색
				self.$modelCodeSearchBox.on('click', '.search-layer .autocomplete-box a', function(e) {
					e.preventDefault();
					var $this = $(this),
						data = $this.data();
					
					self.param = $.extend(self.param, {
						category: data.category,
						subCategory: data.subCategory,
						categoryNm: data.categoryNm,
						subCategoryNm: data.subCategoryNm,
						modelCode: data.modelCode,
						productCode: data.productCode,
						salesModelCode:	data.salesModelCode
					});
					
					$('#category').val(data.category);
					$('#categoryNm').val(data.categoryNm);
					$('#subCategory').val(data.subCategory);
					$('#subCategoryNm').val(data.subCategoryNm);
					$('#modelCode').val(data.modelCode);
					$('#productCode').val(data.productCode);
					$('#salesModelCode').val(data.salesModelCode);

					self.$cont.vcSearchModelNew('updateSummary', {
						product: [data.categoryNm, data.subCategoryNm, data.modelCode],
						isMyProduct: $('#isMyProduct').val(),
						reset: 'product'
					});
				
					self.$selectedModelBar.show(); // 플로팅바 노출
					self.$stepArea.show(); // 정보 입력창 노출
					self.$myModelWrap.hide(); // 제품 리스트 은폐
					
					self.$contentsjobDiv.show();
					self.$stepInput.addClass('active');
					
					self.downloadSearchChk();

					// self._requestSearchEngine();
					// self._requestTopicData();
					
					//조회 관련 부분
					$.extend(self.param, {
						category:      $('#category').val(),
						categoryNm:    $('#categoryNm').val(), 
						subCategory:   $('#subCategory').val(),
						subCategoryNm: $('#subCategoryNm').val(), 
						modelCode:     $('#modelCode').val(),
						productCode:   $('#productCode').val()
					});
					
					$.extend(self.manualPara, {
							category:      $('#category').val(),
							categoryNm:    $('#categoryNm').val(), 
							subCategory:   $('#subCategory').val(),
							subCategoryNm: $('#subCategoryNm').val(), 
							modelCode:     $('#modelCode').val(),
							productCode:   $('#productCode').val()
					});
					$.extend(self.driverParam, {
							category:      $('#category').val(),
							categoryNm:    $('#categoryNm').val(), 
							subCategory:   $('#subCategory').val(),
							subCategoryNm: $('#subCategoryNm').val(), 
							modelCode:     $('#modelCode').val(),
							productCode:   $('#productCode').val()
					});


					if($('#modelCode').val() == ""){
						$('#notmodel').show();
						self.$stepInput.removeClass('active');
					}else{
						$('#notmodel').hide();
						self.$stepInput.addClass('active');
					}


					self.searchAllList();
					// self.onLoadTabControl();  //스스로 해결진입 기준으로 탭 표시
				});
				

				// tab3 tab4
				// self.$solutionsTabBar.on('click', 'li a', function() {
					
				// 	var $tab = $(this).attr('href');
				// 	var $banner = $('.banner-wrap.toggle-banner');

				// 	if($tab == '#tab3') {
				// 		$banner.css('display') === 'block' ? $banner.hide() : '';
						
				// 	}else if($tab == '#tab4') {
				// 		self.bannerToggle($('#subCategory').val());
				// 	}
				// });
			}
		}
		

			
		
		download.initialize();
		
		
	});
	
})();